import {
  useSelectedValueAttributeByKey,
  useSelectedValueByVariableKey,
} from '@k3/core';
import { useMemo } from 'react';
import { OrderCallbackComponent } from '../../../hooks/useOrderCallback';

const useTischComponents = () => {
  const kabelwanne = useSelectedValueByVariableKey('kabelwanne');
  const kabelnetz = useSelectedValueByVariableKey('kabelnetz');

  const kabelkette = useSelectedValueByVariableKey('kabelkette');
  const kabelkettenNumber = useSelectedValueAttributeByKey(
    'kabelkette',
    'number'
  );

  const orgabox = useSelectedValueByVariableKey('orgabox');
  const orgaboxNumber = useSelectedValueAttributeByKey('orgabox', 'number');

  const kasten = useSelectedValueByVariableKey('kasten');
  const kastenPosition = useSelectedValueByVariableKey('kastenPosition');

  const kabeldurchlass = useSelectedValueByVariableKey('kabeldurchlass');
  const kabeldurchlassFarbe = useSelectedValueByVariableKey(
    'kabeldurchlassFarbe'
  );
  const kabeldurchlassNumber = useSelectedValueAttributeByKey(
    'kabeldurchlass',
    'number'
  );

  const kabelwanneEck = useSelectedValueByVariableKey('kabelwanneEck');
  const kabelwanneEckNumber = useSelectedValueAttributeByKey(
    'kabelwanneEck',
    'number'
  );

  const kabelnetzEck = useSelectedValueByVariableKey('kabelnetzEck');
  const kabelnetzEckNumber = useSelectedValueAttributeByKey(
    'kabelnetzEck',
    'number'
  );

  const kabelketteLinks = useSelectedValueByVariableKey('kabelketteLinks');
  const kabelketteLinksNumber = useSelectedValueAttributeByKey(
    'kabelketteLinks',
    'number'
  );

  const kabelketteRechts = useSelectedValueByVariableKey('kabelketteRechts');
  const kabelketteRechtsNumber = useSelectedValueAttributeByKey(
    'kabelketteRechts',
    'number'
  );

  const kabeldurchlassLinks = useSelectedValueByVariableKey(
    'kabeldurchlassLinks'
  );
  const kabeldurchlassLinksNumber = useSelectedValueAttributeByKey(
    'kabeldurchlassLinks',
    'number'
  );

  const kabeldurchlassRechts = useSelectedValueByVariableKey(
    'kabeldurchlassRechts'
  );
  const kabeldurchlassRechtsNumber = useSelectedValueAttributeByKey(
    'kabeldurchlassRechts',
    'number'
  );

  return useMemo(() => {
    const components: OrderCallbackComponent[] = [];
    if (kabelwanne && kabelwanne.value === '1')
      components.push({ component: 'Kabelwanne', number: 1, props: '' });

    if (kabelnetz && kabelnetz.value === '1')
      components.push({ component: 'Kabelnetz', number: 1, props: '' });

    if (kabelkettenNumber && kabelkettenNumber.value)
      components.push({
        component: 'Kabelkette',
        number: +kabelkettenNumber.value,
        props: kabelkette?.label ?? '',
      });

    if (orgaboxNumber && orgaboxNumber.value)
      components.push({
        component: 'Organisationsbox',
        number: +orgaboxNumber.value,
        props: orgabox?.label ?? '',
      });

    if (kasten && kasten.key !== '$noSelection')
      components.push({
        component: kasten.label,
        number: 1,
        props: kastenPosition ? `Position: ${kastenPosition.label}` : '',
      });

    if (kabeldurchlassNumber && kabeldurchlassNumber.value)
      components.push({
        component: 'Kabeldurchlass',
        number: +kabeldurchlassNumber.value,
        props: `${kabeldurchlass?.label ?? ''}, ${
          kabeldurchlassFarbe?.label ?? ''
        }`,
      });

    if (kabelwanneEck && kabelwanneEckNumber?.value)
      components.push({
        component: 'Kabelwanne',
        number: +kabelwanneEckNumber.value,
        props: kabelwanneEck?.label ?? '',
      });

    if (kabelnetzEck && kabelnetzEckNumber?.value)
      components.push({
        component: 'Kabelnetz',
        number: +kabelnetzEckNumber.value,
        props: kabelnetzEck?.label ?? '',
      });

    if (kabelketteLinks && kabelketteLinksNumber?.value)
      components.push({
        component: 'Kabelkette Linker Schenkel',
        number: +kabelketteLinksNumber.value,
        props: kabelketteLinks?.label ?? '',
      });

    if (kabelketteRechts && kabelketteRechtsNumber?.value)
      components.push({
        component: 'Kabelkette Rechter Schenkel',
        number: +kabelketteRechtsNumber.value,
        props: kabelketteRechts?.label ?? '',
      });

    if (kabeldurchlassLinks && kabeldurchlassLinksNumber?.value)
      components.push({
        component: 'Kabeldurchlass Linker Schenkel',
        number: +kabeldurchlassLinksNumber.value,
        props: kabeldurchlassLinks?.label ?? '',
      });

    if (kabeldurchlassRechts && kabeldurchlassRechtsNumber?.value)
      components.push({
        component: 'Kabeldurchlass Rechter Schenkel',
        number: +kabeldurchlassRechtsNumber.value,
        props: kabeldurchlassRechts?.label ?? '',
      });

    return components;
  }, [
    kabelwanne,
    kabelnetz,
    kabelkette,
    kabelkettenNumber,
    orgabox,
    orgaboxNumber,
    kasten,
    kastenPosition,
    kabeldurchlass,
    kabeldurchlassNumber,
    kabeldurchlassFarbe,
    kabelwanneEck,
    kabelwanneEckNumber,

    kabelnetzEck,
    kabelnetzEckNumber,
    kabelketteLinks,
    kabelketteLinksNumber,
    kabelketteRechts,
    kabelketteRechtsNumber,
    kabeldurchlassLinks,
    kabeldurchlassLinksNumber,
    kabeldurchlassRechts,
    kabeldurchlassRechtsNumber,
  ]);
};

export { useTischComponents };
